import { setToObject } from "@/utils/object";
export default function setDataReducer(state, payload) {
    // variables
    let valuesArray = Array.isArray(payload) ? payload : [
        payload
    ];
    let paths = valuesArray.map((param)=>{
        let { path } = param;
        return path;
    });
    let helper = {
        ...state || {}
    };
    valuesArray.forEach((value)=>{
        helper = setToObject(helper, value.path, value.value);
    });
    return Object.fromEntries(paths.map((path)=>[
            path,
            helper[path]
        ]));
}
;
